export default __webpack_public_path__ + "static/media/de37e7921829372a8dcca16af7eb64bd.svg";